<template>
    <section>
        <div class="container pb-5 userAccountCont">
            <div class="row">
                <div class="col-12">
                    <h2 class="text-center mb-5">Orders Management</h2>
                </div>
            </div>
            <div class="row vld-parent" ref="uord_main_ref">
                <div class="col-12">
                    <div class="accordion" id="accordionExample">
                        <div class="card">
                            <template v-if="orders && orders.data" v-for="(order, index) in orders.data"  >
                                <div class="card-header" :id="'headingOne'+index" :key="'p'+index">
                                    <h2 class="mb-0">
                                        <div class="d-flex justify-content-between tabInfo" type="button"
                                            data-toggle="collapse" :data-target="'#collapseOne'+index" aria-expanded="true"
                                            :aria-controls="'collapseOne'+index">
                                            <div class="infoColumn">
                                                <p class="infoTitle">Order Number: {{ order.id }}</p>
                                                <p>{{order.order_date }}</p>
                                            </div>
                                            <div class="infoColumn" v-if="order.estimate_time">
                                                <p class="infoTitle"><img src="images/truck.png"
                                                        class="img-fluid avIcon">
                                                    Average Time estimation:</p>
                                                <p v-text="order.estimate_time"></p>
                                            </div>
                                        </div>
                                    </h2>
                                </div>
                                <div :id="'collapseOne'+index" class="collapse " :class="{show:index==0}" :aria-labelledby="'headingOne'+index"
                                    data-parent="#accordionExample" :key="'s'+index">
                                    <div class="card-body">
                                        <div class="orderListRow d-flex flex-wrap justify-content-between align-items-center" v-for="(item, oi) in order.order_trans" :key="oi" v-if="order.order_trans">
                                            <div class="d-flex orderGeneralInfo">
                                                <div class="orderImgWrpr">
                                                    <img :src="set_image(item.photo)" class="img-fluid" height="255" width="230">
                                                </div>
                                                <div class="orderDetails">
                                                    <p class="name">{{ item.product_name }}  {{ item.project? '(Project ID-'+ item.project.id+')':'' }} </p>
                                                    <p>
                                                        <span class="textLightGray">Width:</span><span>&nbsp;</span>
                                                        <span class="textBold600" v-text="item.width_size"></span>
                                                        <span>&nbsp;&nbsp;&nbsp;</span>
                                                        <span class="textLightGray">Height:</span><span>&nbsp;</span>
                                                        <span class="textBold600" v-text="item.height_size"> </span>
                                                    </p>
                                                    <p>
                                                        <span class="textLightGray">Qty:</span><span>&nbsp;</span>
                                                        <span class="textBold600" v-text="item.qty">2</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="orderPrice">
                                                <span class="textLightGray">Price: </span><span>&nbsp;</span>
                                                <span class="textBold600">{{ item.item_total_price|toCurrency }}</span>
                                            </div>
                                            <div class="orderStatus">
                                                <p class="textGreen textBold500" v-if="order.status=='Payment Pending'">Payment Pending/Failed</p>
                                                <p class="textGreen textBold500" v-text="item.status" v-else></p>
                                            </div>
                                        </div>
                                    <a :href="'https://wevisu.com/order/invoice/'+order.id" target="_blank" class="textGreen textBold500">View/Download Receipt</a>

                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>

                <UjPagination @fetchRecord="val=>get_my_orders(val)" :records="orders" scrollto="accordionExample" v-if="orders.total>0" />


                </div>
                <div class="col-12">
                    <p class="m-0 orderHelp mt-5
                ">Order Problems? <router-link to="/contact" target="_blank" style="color: #212529;"><u>Get help</u> </router-link> <img src="images/customer-service.png" class="img-fluid"></p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "User-order",
    props: ['filtertab'],
    components: {},
    data() {
        return {
            orders: '',
            ppp:10,
            search:'',
        }
    },
    watch: {
        async filtertab(n, o) {
            if (n == 'Orders') {
                await this.get_my_orders();
            }
        },
        async ppp(){
            await this.get_my_orders()
        }
    },
    methods: {
async get_my_orders(url = "/api/order") {
	            let loaderd = this.$loading.show({
	                container: this.$refs.uord_main_ref,
	            });
	            axios.get(url, {
	                    params: {
	                        search: this.search,
	                        ppp: this.ppp,
	                    }
	                })
	                .then((res) => {
	                    this.selected = []
	                    this.orders = res.data.data
	                    loaderd.hide()
	                })
	                .catch(err => {
	                    loaderd.hide()
	                });
	        },
    }
}
</script>
